<template>
  <div
    class="hero is-fullheight fullpage-section"
    data-anchor="section-testimonios"
  >
    <div
      class="columns height100 is-hidden-touch"
      v-bind:class="{
        'is-hidden': indexTestimonios !== 0
      }"
    >
      <div
        class="column is-3-desktop background-testimonio-amaro"
        v-on:mouseover="indexHover = 1"
        v-on:mouseout="indexHover = 0"
        v-on:click="
          (indexTestimonios = 1),
            descriptionActualTxt(),
            bajadaActualTxt(),
            nombreActualTxt()
        "
        v-bind:class="{ fade: indexHover === 1 }"
      ></div>
      <div
        class="column is-3-desktop background-testimonio-melisa"
        v-on:mouseover="indexHover = 2"
        v-on:mouseout="indexHover = 0"
        v-on:click="
          (indexTestimonios = 2),
            descriptionActualTxt(),
            bajadaActualTxt(),
            nombreActualTxt()
        "
        v-bind:class="{ fade: indexHover === 2 }"
      ></div>
      <div
        class="column is-3-desktop background-testimonio-guido"
        v-on:mouseover="indexHover = 3"
        v-on:mouseout="indexHover = 0"
        v-on:click="
          (indexTestimonios = 3),
            descriptionActualTxt(),
            bajadaActualTxt(),
            nombreActualTxt()
        "
        v-bind:class="{ fade: indexHover === 3 }"
      ></div>
      <div
        class="column is-3-desktop background-testimonio-javier"
        v-on:mouseover="indexHover = 4"
        v-on:mouseout="indexHover = 0"
        v-on:click="
          (indexTestimonios = 4),
            descriptionActualTxt(),
            bajadaActualTxt(),
            nombreActualTxt()
        "
        v-bind:class="{ fade: indexHover === 4 }"
      ></div>
    </div>
    <div
      class="column height100 is-hidden-touch"
      @click="indexTestimonios = 0"
      v-bind:class="{
        'is-hidden': indexTestimonios === 0,
        'background-full-testimonio-amaro': indexTestimonios === 1,
        'background-full-testimonio-melisa': indexTestimonios === 2,
        'background-full-testimonio-guido': indexTestimonios === 3,
        'background-full-testimonio-javier': indexTestimonios === 4
      }"
    >
      <div class="column is-half">
        <div class="column height30"></div>
        <div class="column is-10-desktop">
          <div class="columns dark-background">
            <div class="column is-1-desktop"></div>
            <div class="column">
              <div class="column"></div>
              <p
                id="nombreTestimonios"
                class="has-font-unica is-size-2 white-color"
                onload="descriptionActualTxt()"
              ></p>
              <p
                id="bajadaTestimonios"
                class="is-size-5 white-color font-style-italic"
                onload="bajadaActualTxt()"
              ></p>
              <br />
              <p
                id="descriTestimonios"
                class="is-size-4 white-color"
                onload="nombreActualTxt()"
              ></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile behavior -->
    <div
      class="column height100 is-hidden-desktop dark-background"
      v-bind:class="{
        'background-testimonio-amaro': indexTestimonios === 0,
        'background-testimonio-melisa': indexTestimonios === 1,
        'background-testimonio-guido': indexTestimonios === 2,
        'background-testimonio-javier': indexTestimonios === 3
      }"
    >
      <div
        class="column is-half mobile-elements-color has-font-unica is-size-2"
        align="center"
      >
        <p class="is-hidden-desktop">TESTIMONIOS</p>
      </div>
      <div class="column height50"></div>
      <div class="columns is-mobile">
        <div class="column is-3-touch">
          <img
            :src="getImg('Testimonios/Flecha-Izquierda.png')"
            alt=""
            v-on:click="
              (indexTestimonios = (indexTestimonios - 1 + 4) % 4),
                descriptionActualTxt(),
                bajadaActualTxt(),
                nombreActualTxt()
            "
          />
        </div>
        <div class="column is-6-touch dark-background">
          <div class="column is-paddingless">
            <p
              id="nombreTestimoniosMobile"
              class="has-font-unica is-size-2 is-size-5-touch white-color"
              onload="descriptionActualTxt()"
            >
              Amaro <br />
              Fica
            </p>
            <p
              id="bajadaTestimoniosMobile"
              class="is-size-7-touch white-color font-style-italic"
              onload="bajadaActualTxt()"
            >
              <em
                >Deportista Paralímpico <br />
                24 años
              </em>
            </p>
            <br class="is-hidden-touch" />
            <p
              id="descriTestimoniosMobile"
              class="is-size-6-touch white-color"
              onload="nombreActualTxt()"
            >
              “Los niños me preguntan si soy <br />un transformer”
            </p>
          </div>
        </div>
        <div class="column is-3-touch">
          <img
            :src="getImg('Testimonios/Flecha-Derecha.png')"
            alt=""
            v-on:click="
              (indexTestimonios = (indexTestimonios + 1) % 4),
                descriptionActualTxt(),
                bajadaActualTxt(),
                nombreActualTxt()
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getImg } from '@/utils/assets-helpers'

export default {
  name: 'Testimonios',
  methods: {
    getImg,
    descriptionActualTxt() {
      document.getElementById(
        'descriTestimonios'
      ).innerHTML = this.descriTestimonios[this.indexTestimonios - 1]
      document.getElementById(
        'descriTestimoniosMobile'
      ).innerHTML = this.descriTestimonios[this.indexTestimonios]
    },
    bajadaActualTxt() {
      document.getElementById(
        'bajadaTestimonios'
      ).innerHTML = this.bajadaTestimonios[this.indexTestimonios - 1]
      document.getElementById(
        'bajadaTestimoniosMobile'
      ).innerHTML = this.bajadaTestimonios[this.indexTestimonios]
    },
    nombreActualTxt() {
      document.getElementById(
        'nombreTestimonios'
      ).innerHTML = this.nombreTestimonios[this.indexTestimonios - 1]
      document.getElementById(
        'nombreTestimoniosMobile'
      ).innerHTML = this.nombreTestimonios[this.indexTestimonios]
    }
  },
  data: function() {
    return {
      indexHover: 0,
      indexTestimonios: 0,
      nombreTestimonios: [
        'Amaro <br /> Fica',
        'Melisa',
        'Guido <br /> Espinoza',
        'Javier <br /> Jiménez'
      ],
      bajadaTestimonios: [
        '<em>Deportista Paralímpico <br /> 24 años</em>',
        '<em>Región Metropolitana</em>',
        '<em>38 años</em>',
        '<em>Deportista Paralímpico <br /> 24 años</em>'
      ],
      descriTestimonios: [
        '“Los niños me preguntan si soy <br class="is-hidden-touch" />un transformer”',
        '“Me siento como si fuese real”',
        '“Me trae estilo y encaja <br class="is-hidden-touch" /> bien en mi ropa”',
        '“Una funda puede hacer cambios, y que <br class="is-hidden-touch" />' +
          'las personas al verme, vean a una <br class="is-hidden-touch" />' +
          'persona con actitud, llena de alegría y <br class="is-hidden-touch" />' +
          'seguridad”'
      ]
    }
  }
}
</script>

<style scoped>
.height100 {
  height: 100vh;
}
.height30 {
  height: 30vh;
}
.height50 {
  height: 50vh;
}
.mobile-elements-color {
  color: #00adee;
}
.font-style-italic {
  font-style: italic;
}
.background-testimonio-amaro {
  background-image: url('../assets/img/Testimonios/fondo-amaro.jpg');
  background-size: cover;
}
.background-testimonio-melisa {
  background-image: url('../assets/img/Testimonios/fondo-melisa.jpg');
  background-size: cover;
}
.background-testimonio-guido {
  background-image: url('../assets/img/Testimonios/fondo-guido.jpg');
  background-size: cover;
}
.background-testimonio-javier {
  background-image: url('../assets/img/Testimonios/fondo-javier.jpg');
  background-size: cover;
}
.background-full-testimonio-amaro {
  background-image: url('../assets/img/Testimonios/smooth-amaro.jpg');
  background-size: cover;
}
.background-full-testimonio-melisa {
  background-image: url('../assets/img/Testimonios/smooth-melisa.jpg');
  background-size: cover;
}
.background-full-testimonio-guido {
  background-image: url('../assets/img/Testimonios/smooth-guido.jpg');
  background-size: cover;
}
.background-full-testimonio-javier {
  background-image: url('../assets/img/Testimonios/smooth-javier.jpg');
  background-size: cover;
}
.dark-background {
  background-color: rgba(0, 0, 0, 0.5);
}

@keyframes icon-move {
  0% {
    opacity: 1;
  }
  1% {
    opacity: 0.6;
  }
}
.fade {
  animation-name: icon-move;
  animation-duration: 100s;
}
</style>
